import gql from 'graphql-tag';

export default gql`
    mutation AddAndSaveDriversToPool($input: AddAndSaveDriversToPoolRequest) {
        addAndSaveDriversToPool(input: $input) {
            errors
        }
    }
`;
